import lazyPage from "../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/pages/home/Pride/Pride.tsx",
    () => import("./Pride"),
);
